/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applicants_Bulk_Attendance_Confirm_ButtonInputs */

const en_applicants_bulk_attendance_confirm_button = /** @type {(inputs: Applicants_Bulk_Attendance_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as attended`)
};

const de_applicants_bulk_attendance_confirm_button = /** @type {(inputs: Applicants_Bulk_Attendance_Confirm_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als teilgenommen markieren`)
};

/**
* | output |
* | --- |
* | "Mark as attended" |
*
* @param {Applicants_Bulk_Attendance_Confirm_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_attendance_confirm_button = /** @type {((inputs?: Applicants_Bulk_Attendance_Confirm_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Attendance_Confirm_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_attendance_confirm_button(inputs)
	return en_applicants_bulk_attendance_confirm_button(inputs)
});